<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import { TweenMax as Tween, Power1, Power2 } from 'gsap'

export default {

  name: 'LoadMoreButton',

  computed: {
    isLoading () {
      return this.$store.getters['pages/loading']
    }
  },

  methods: {
    enter (el, done) {
      Tween.from(el, 1, {
        autoAlpha: 0,
        delay: 1,
        ease: Power1.easeOut,
        onComplete: done
      })
    },

    leave (el, done) {
      Tween.to(el, 1, {
        autoAlpha: 0,
        ease: Power1.easeOut,
        onComplete: done
      })
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

button.button(type="button" @click="$emit('click')")
  .button-wrapper
    .button-circle(:class="[isLoading ? 'is-loading' : '']")
      .button-dot(v-for="dot in [,,,]")
    .button-label {{ isLoading ? $t('load') : $t('load-more') }}

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

.button
  display block
  width 100px
  height 110px

.button-wrapper
  width 100%
  height 100%
  display flex
  flex-direction column
  justify-content space-between
  align-items center
  padding-top 10px
  padding-bottom 10px

.button-circle
  display flex
  justify-content center
  align-items center
  width 53px
  height 53px
  border-radius 50%
  background-color orange

  &.is-loading
  &:focus
    .button-dot
      animation stretchdelay 0.7s infinite ease-in-out

      &:nth-child(1)
        animation-delay -0.5s
      &:nth-child(2)
        animation-delay -0.4s
      &:nth-child(3)
        animation-delay -0.3s

  &:hover
    .button-dot
      animation stretchdelay 0.7s 2 ease-in-out

      &:nth-child(1)
        animation-delay -0.5s
      &:nth-child(2)
        animation-delay -0.4s
      &:nth-child(3)
        animation-delay -0.3s

.button-dot
  display block
  width 5px
  height 5px
  background-color white

  & + &
    margin-left 5px

.button-label
  // margin-top 24px
  font-weight 500
  font-size 14px

 @keyframes stretchdelay
      0%, 40%, 100%
        transform translateY(0px)
      20%
        transform translateY(-10px)

</style>



// WEBPACK FOOTER //
// load-more-button.vue?5ac7568b